import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Switch, RouteComponentProps } from 'react-router-dom';
import { LayoutHeaderFooter } from './_layout';
import { Login } from './login/login';
import { Logout } from './login/logout';
import {
  Main,
  LectureReferenceRoom,
  SampleBook,
  About,
  Policy,
  SupportMain,
  Order,
  Orders,
  Shipping,
  Cart,
  MyPage,
  InformationMain,
  BookDetail,
  BookMain,
  Privacy,
} from './content';

import {
  AdminBanner,
  AdminBannerAdd,
  AdminErrata,
  AdminLecture,
  AdminNotice,
  AdminPublish,
  AdminQna,
  AdminReferenceRoom,
  AdminSampleBook,
  AdminCategories,
  AdminListBook,
  AdminDetailBook,
  AdminProfessor,
  AdminGroupBuying,
  AdminOrderList,
  AdminShipping,
  AdminByBook,
  AdminByMember,
  AdminDashboard,
  AdminPrivacy,
  AdminGroupOrder,
} from './content/admin';
import { Signup } from './login/signup';
import { Signout } from './login/signout';
import { AsideBook } from './_layout/aside-book';
import { AsideAdmin } from './_layout/aside-admin';
import { AsideProfessor } from './_layout/aside-professor';
import { BoardView } from './content/board/boardView';
import { TermsAndPolicies } from './login/terms-and-policies';
import { FindAccount } from './login/find-account';
import { AdminRefund } from './content/admin/etc/refund';
import { AdminNormal } from './content/admin/member/normal';
import { AdminAuthor } from './content/admin/member/author';
import { AdminEntire } from './content/admin/member/entire';
import { AdminAdmin } from './content/admin/member/admin';
import { AdminBoardView } from './content/admin/boder/adminBoardView';
import { AdminBoardWrite } from './content/admin/boder/adminBoardWirte';
import { AdminReplyView } from './content/admin/boder/adminReplyView';
import { AdminReplyWrite } from './content/admin/boder/adminReplyWrite';
import { AdminNewBook } from './content/admin/book/new-book';
import { AdminBannerMod } from './content/admin/banner-logo/banner-mod';
import { AdminAdvertisement } from './content/admin/banner-logo/advertisement';
import { AdminAdvertisementAdd } from './content/admin/banner-logo/advertisment-add';
import { AdminAdvertisementMod } from './content/admin/banner-logo/advertisment-mod';
import { AdminGroupBuyingUpdate } from './content/admin/sale/group-buying-update';
import { AdminOnlineStore } from './content/admin/store/online';
import { AdminOnlineStoreAdd } from './content/admin/store/online-add';
import { AdminOnlineStoreMod } from './content/admin/store/online-mod';
import { AdminOfflineStore } from './content/admin/store/offline';
import { AdminOfflineStoreAdd } from './content/admin/store/offline-add';
import { AdminOfflineStoreMod } from './content/admin/store/offline-mod';
import { Search } from './content/board/search';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function App(routeProps: RouteComponentProps) {
  useEffect(() => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
      const ivh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${ivh}px`);
    });
  }, []);

  return (
    <Router>
      <Switch>
        <Route path="/admin">
          <AsideAdmin {...routeProps}>
            <Switch>
              {/* 관리자용 대시보드 */}
              <Route path="/admin" exact component={AdminDashboard} />
              <Route path="/admin/dashboard" exact component={AdminDashboard} /> {/* 대시보드 */}
              {/* 게시판관리 */}
              <Route path="/admin/board" exact component={AdminNotice} />{' '}
              <Route
                path="/admin/board/adminBoardView/:ctgy/:id"
                exact
                component={AdminBoardView}
              />
              <Route
                path="/admin/board/adminBoardWrite/:ctgy/:id"
                exact
                component={AdminBoardWrite}
              />
              <Route
                path="/admin/board/adminReplyView/:ctgy/:id"
                exact
                component={AdminReplyView}
              />
              <Route
                path="/admin/board/adminReplyWrite/:ctgy/:id"
                exact
                component={AdminReplyWrite}
              />
              {/* 공지사항 */}
              <Route path="/admin/board/notice" exact component={AdminNotice} />
              <Route path="/admin/board/qna" component={AdminQna} /> {/* Qna관리 */}
              <Route path="/admin/board/errata" component={AdminErrata} /> {/* 정오표 */}
              <Route path="/admin/board/lecture-lib" component={AdminLecture} /> {/* 강의자료 */}
              <Route path="/admin/board/publish" component={AdminPublish} /> {/* 출판문의 */}
              <Route path="/admin/board/lib" component={AdminReferenceRoom} /> {/* 자료실 */}
              <Route path="/admin/board/sample-book" component={AdminSampleBook} />{' '}
              {/* 견본도서요청 */}
              {/* 도서관리 */}
              <Route path="/admin/book/categories" component={AdminCategories} />{' '}
              {/* 카테고리 설정 */}
              <Route path="/admin/book/detail/:id" component={AdminDetailBook} />
              {/* 도서 조회 및 수정 */}
              <Route path="/admin/book/list/:bookIs" component={AdminListBook} />
              {/* 신규도서등록 */}
              <Route path="/admin/book/new-book" component={AdminNewBook} />
              {/* 판매관리 */}
              <Route path="/admin/sale/order-list/:orderIs" component={AdminOrderList} />{' '}
              {/* 주문조회 */}
              <Route path="/admin/sale/shipping" component={AdminShipping} /> {/* 배송정보 */}
              <Route path="/admin/sale/group-buying" component={AdminGroupBuying} />{' '}
              <Route
                path="/admin/sale/group-buying-update/:id"
                component={AdminGroupBuyingUpdate}
              />{' '}
              {/* 공동구매 */}
              {/* 회원관리 */}
              <Route path="/admin/member/normal" component={AdminNormal} /> {/* 일반회원관리 */}
              <Route path="/admin/member/professor" component={AdminProfessor} />{' '}
              {/* 교수회원관리 */}
              <Route path="/admin/member/author" component={AdminAuthor} /> {/* 저자회원관리 */}
              <Route path="/admin/member/admin" component={AdminAdmin} /> {/* 관리자 관리 */}
              <Route path="/admin/member/entire" component={AdminEntire} /> {/* 전체회원관리 */}
              {/* 메인배너 */}
              <Route path="/admin/banner-logo/banner" component={AdminBanner} />
              <Route path="/admin/banner-logo/banner-add" component={AdminBannerAdd} />
              <Route path="/admin/banner-logo/banner-mod/:id" component={AdminBannerMod} />
              {/* 광고설정 */}
              <Route path="/admin/banner-logo/advertisement" component={AdminAdvertisement} />
              <Route
                path="/admin/banner-logo/advertisement-add"
                component={AdminAdvertisementAdd}
              />
              <Route
                path="/admin/banner-logo/advertisement-mod/:id"
                component={AdminAdvertisementMod}
              />{' '}
              {/* 통계 */}
              <Route path="/admin/statistics" exact component={AdminByBook} /> {/* 통계관리 */}
              <Route path="/admin/statistics/by-book" component={AdminByBook} /> {/* 도서별통계 */}
              {/* 회원별통계 */}
              <Route path="/admin/statistics/by-member" component={AdminByMember} />
              {/* 기타 */}
              <Route path="/admin/etc" exact component={AdminPrivacy} /> {/* 개인정보수집약관 */}
              <Route path="/admin/etc/privacy" component={AdminPrivacy} /> {/* 개인정보수집약관 */}
              {/* 단체주문안내 */}
              <Route path="/admin/etc/group-order" component={AdminGroupOrder} />
              {/* 반품환불정보 */}
              <Route path="/admin/etc/refund" component={AdminRefund} />
              {/* 서점 */}
              <Route path="/admin/store/online" component={AdminOnlineStore} />
              <Route path="/admin/store/online-add" component={AdminOnlineStoreAdd} />
              <Route path="/admin/store/online-mod/:id" component={AdminOnlineStoreMod} />
              <Route path="/admin/store/offline" component={AdminOfflineStore} />
              <Route path="/admin/store/offline-add" component={AdminOfflineStoreAdd} />
              <Route path="/admin/store/offline-mod/:id" component={AdminOfflineStoreMod} />
            </Switch>
          </AsideAdmin>
        </Route>
        <Route path="/">
          <LayoutHeaderFooter {...routeProps}>
            <Switch>
              <Route path="/" exact component={Main} />
              <Route path="/index" component={Main} />
              <Route path="/login" component={Login} />
              <Route path="/logout" component={Logout} />
              <Route path="/signup" component={Signup} />
              <Route path="/signout" component={Signout} />
              <Route path="/find-account" component={FindAccount} />
              <Route path="/terms-policies" component={TermsAndPolicies} />

              {/* 검색관련 */}
              <Route path="/board?search=:keywords" component={Search} />

              {/* 게시판관련 */}
              <Route path="/board" component={SupportMain} />

              {/* 정보안내 */}
              <Route path="/info" component={InformationMain} />
              {/* 도서관련 */}
              <Route path="/books" exact component={AsideBook} />
              <Route path="/books/:id" exact component={BookDetail} />
              {/* <Route path="/book-categories/" exact component={BookMain} />
              <Route path="/book-categories/:id" exact component={BookMain} /> */}
              <Route path="/book-categories/:id/books" component={BookMain} />

              {/* 주문관련 */}
              <Route path="/order" exact component={Order} />
              <Route path="/orders" exact component={Orders} />
              <Route path="/order/shipping" exact component={Shipping} />
              <Route path="/order/cart" exact component={Cart} />
              <Route path="/mypage" component={MyPage} />

              {/* 교수전용 */}
              <Route path="/professor/lecture-material" component={LectureReferenceRoom} />
              <Route path="/professor/request-sample" component={SampleBook} />
              <Route path="/professor/boardView">
                <main className="sub wrapper board-view">
                  <AsideProfessor />
                  <Route path="/professor/boardView" component={BoardView} />
                </main>
              </Route>
              {/* 사이트맵 */}
              <Route path="/sitemap/about" component={About} />
              <Route path="/sitemap/policy" component={Policy} />
              <Route path="/sitemap/privacy" component={Privacy} />
            </Switch>
          </LayoutHeaderFooter>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
